// src/pages/Faqs.jsx
import { motion } from "framer-motion";
import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t, i18n } = useTranslation();
  const faqs = [
  {
    question: t("faqPage.faq1.question"),
    answer: t("faqPage.faq1.answer"),
  },
  {
    question: t("faqPage.faq2.question"),
    answer: t("faqPage.faq2.answer"),
  },
  {
    question: t("faqPage.faq3.question"),
    answer: t("faqPage.faq3.answer"),
  },
  {
    question: t("faqPage.faq4.question"),
    answer: t("faqPage.faq4.answer"),
  },
  {
    question: t("faqPage.faq5.question"),
    answer: t("faqPage.faq5.answer"),
  },
  {
    question: t("faqPage.faq6.question"),
    answer: t("faqPage.faq6.answer"),
  },
  {
    question: t("faqPage.faq7.question"),
    answer: t("faqPage.faq7.answer"),
  },
  {
    question: t("faqPage.faq8.question"),
    answer: t("faqPage.faq8.answer"),
  },
];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="bg-black text-white py-20 px-6 md:px-16 lg:px-24 font-ur">
      <div className="max-w-5xl mx-auto">
        <motion.h1
          className="text-4xl md:text-5xl font-bold text-center mb-12 bg-gradient-to-r from-blue-400 via-blue-500 to-cyan-400 text-transparent bg-clip-text"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
         {t("faqPage.heading")}
        </motion.h1>

        <motion.p
          className="text-center text-gray-400 mb-10 max-w-3xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          {t("faqPage.description")}
        </motion.p>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="border border-gray-700 rounded-2xl overflow-hidden bg-gradient-to-r from-gray-900 to-gray-800 shadow-lg shadow-blue-900/30 hover:shadow-blue-500/30 transition"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * index }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between items-center p-5 text-left"
              >
                <span className="text-lg md:text-xl font-medium text-blue-300 hover:text-blue-400 transition">
                  {faq.question}
                </span>
                <FaChevronDown
                  className={`transition-transform duration-300 ${
                    activeIndex === index ? "rotate-180 text-blue-400" : "text-gray-400"
                  }`}
                />
              </button>

              {activeIndex === index && (
                <motion.div
                  className="px-5 pb-5 text-gray-300 leading-relaxed"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  transition={{ duration: 0.4 }}
                >
                  {faq.answer}
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          className="mt-16 text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
        >
          <p className="text-gray-400 text-sm">
           {t("faqPage.disclaimer")}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Faqs;
